<div class="subject-facet-wrapper selenium-subject-facet">
    <div class="facet-title" (click)="onToggle()">
        <span class="toggle visible">
            <i
                [@rotateRight]="isCollapsed"
                class="fas"
                [ngClass]="{ 'fa-plus': isCollapsed, 'fa-minus': !isCollapsed }"
            ></i>
        </span>
        {{ title }}
        <span *ngIf="selectedFiltersCount">({{ selectedFiltersCount }})</span>
    </div>
    <div [@fadeInXY]="!isCollapsed" *ngIf="!isCollapsed" class="facet-content">
        <app-nested-facet-nodes
            *ngFor="let facetNode of topLevel"
            [facet]="facet"
            [facetNode]="facetNode"
        ></app-nested-facet-nodes>
    </div>
</div>
